export { default as Heading, type HeadingProps } from './Heading';
